module.exports = __webpack_public_path__ + "img/right4.778676c2.png";